<template>
  <div class="body" style="direction: rtl;">
    <v-row>
      <v-col cols="12" md="6">
        <div class="mt-10 pa-10 text-center">
            <div class="errorMesg" v-if="showerr">{{ loginError || lang.system_login_invalid }}</div>
            <div class="mt-16" :style="`border-radius:10px;color:#FFF;background:rgb(0, 0, 0);margin:auto;direction: `+this.lang.dir+`;width:300px;border:1px solid #000`">
              <div class="text-start pa-3">
                <label for="input-live">{{lang.login_name}}</label>
                  <b-form-input
                    id="username"
                    v-model="username"
                    @keyup.enter="enterlogin()"
                    aria-describedby="input-live-help input-live-feedback"
                    :placeholder="lang.login_name"
                    @keyup.native.enter="doLogin()"
                    trim
                  ></b-form-input>
                  <b-form-invalid-feedback v-if="!nameState" id="input-live-feedback">
                    {{lang.required_field}}
                  </b-form-invalid-feedback>
              </div>
              <div class="text-start pa-3 pt-0">
                <label for="input-live">{{lang.password}}</label>
                  <b-form-input
                    id="password"
                    v-model="password"
                    @keyup.enter="enterlogin()"
                    aria-describedby="input-live-help input-live-feedback"
                    :placeholder="lang.password"
                    @keyup.native.enter="doLogin()"
                    type="password"
                    trim
                  ></b-form-input>
                  <b-form-invalid-feedback v-if="!passState" id="input-live-feedback">
                    {{lang.required_field}}
                  </b-form-invalid-feedback>
              </div>
              <div class="pa-3 pt-0" style="display:flex;flex-direction:row;justify-content:space-between;flex-wrap:wrap" v-if="branches.length > 1">
                  <div class="text-start" style="direction:rtl;width:50%"  v-for="(item , index) in branches" :key="index">
                    <button class="btn btn-success" :id="`branch${item.id}`" @click="changeBranch(item.id)" :style="branchButtonStyle(item.id)" style="font-size:1rem;border:1px solid #000;width:100%;border-radius:0;font-weight:bolder">{{ item[`name_${lang.langname}`] }}</button>
                  </div>
              </div>
              <div class="pa-3 pt-0" style="display:flex;flex-direction:row;justify-content:space-between;flex-wrap:wrap" v-if="financeYear.length > 1">
                  <div class="text-start" style="direction:rtl;width:100%">
                    <b-form-select class="selborder" @change="setFinanceYear()" v-model="fYear" :options="FinYears" />
                  </div>
              </div>

              <div class="text-start pa-3 pt-0" style="direction:rtl">
                  <button class="btn btn-success" id="arabic" v-if="$store.state.licenseType.activemenu != 'ofatora'" @click="changeLang('ar','ar')" :style="languageButtonStyle('ar')" style="border:1px solid #000;width:50%;border-radius:0;font-weight:bolder">عربي</button>
                  <button class="btn btn-success" v-if="$store.state.licenseType.activemenu == 'ofatora'" id="urdu" @click="changeLang('ur','ur')" :style="languageButtonStyle('ur')" style="border:1px solid #000;width:50%;border-radius:0;font-weight:bolder">أوردو</button>
                  <button class="btn btn-success" id="english" @click="changeLang('en','en')" :style="languageButtonStyle('en')" style="border:1px solid #000;width:50%;border-radius:0;font-weight:bolder">English</button>
              </div>
              <div style="margin:20px 5px;display:flex;justify-content: center;justify-items: center;">
                <b-button :disabled="loggingIn" @click="doLogin()" type="button" class="bgbalck" style="font-size: small;width:50%;background:#84c8ff !important;color:#000 !important;font-weight:bolder"> {{ lang.system_login_label }}&nbsp;	&nbsp;	<i class="fas fa-sign-in-alt"></i></b-button>
<!-- From Uiverse.io by vinodjangid07 -->
<button class="Btn-Container" style="display:none;" @click="doLogin()">
  <span class="text">{{ lang.system_login_label }}</span>
  <span class="icon-Container">
    <svg
      width="16"
      height="19"
      viewBox="0 0 16 19"
      fill="nones"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="1.61321" cy="1.61321" r="1.5" fill="black"></circle>
      <circle cx="5.73583" cy="1.61321" r="1.5" fill="black"></circle>
      <circle cx="5.73583" cy="5.5566" r="1.5" fill="black"></circle>
      <circle cx="9.85851" cy="5.5566" r="1.5" fill="black"></circle>
      <circle cx="9.85851" cy="9.5" r="1.5" fill="black"></circle>
      <circle cx="13.9811" cy="9.5" r="1.5" fill="black"></circle>
      <circle cx="5.73583" cy="13.4434" r="1.5" fill="black"></circle>
      <circle cx="9.85851" cy="13.4434" r="1.5" fill="black"></circle>
      <circle cx="1.61321" cy="17.3868" r="1.5" fill="black"></circle>
      <circle cx="5.73583" cy="17.3868" r="1.5" fill="black"></circle>
    </svg>
  </span>
</button>

              </div>

            </div>
            <div class="text-center" style="color:black">SAMCOTEC V {{$store.state.Version}}</div>
            <div class="loginSupport">{{ lang.for_more_information_or_support_firstline }}</div>
            <div class="loginSupport" style="padding:5px;border:1px solid #000;background:#FFF; ">{{ lang.for_more_information_or_support_secondline }}</div>
        </div>
        </v-col>
        <v-col style="position:relative;background:#fff;color:#000;height:100vh;margin-top:-3px;border-bottom:3px solid #84c8ff;border-top:3px solid #84c8ff;border-right:3px solid #000;border-left:3px solid #84c8ff" cols="12" md="6">
          <div class="pa-5 mt-16 text-center" style="padding-top:25% !important">
            <img :src="`../img/samcotec-logo.png`" v-if="!$store.state.licenseType.cars && lang.langname != 'ur'" style="width:130px;">
            <img :src="`../img/urdo-logo.jpeg`" v-else-if=" lang.langname == 'ur'" style="width:130px;">
            <img :src="`../img/${$store.state.logo}`" v-else style="width:130px;">
          </div>
          <div class="pa-5 mt-16 text-center" style="padding-top:10px !important">
              <img :src="`../img/safip.png`" style="width:200px" />
              <div style="margin-top:10px;text-align: center;">
                <div style="margin-top:10px;text-align: center;"><span style="color:red">تحذيـر </span>
                  يمنع إعادة إنتاج البرنامج وملحقاته بشكل كامـل أو تقليـده دون زيـادة أو نقصان أو أجراء أي تعديل عليه
                  هذا المنتج تملكة شركة سام لتقنية المعلومات المحدوده – الرياض بموجب العلامه التجارية SAMCOTEC

                </div>
                <div style="margin-top:10px;text-align: center;">
                   باعتماد الهيئة السعودية للملكية الفكرية برقم: 1435022395 وتاريخ 05-01-1436
                </div>
              </div>
              <div class="loginSupport" style="display:none;"><br />{{ lang.for_more_information_or_support }}</div>
          </div>
        </v-col>
    </v-row>

  </div>
</template>

<script>
import axios from 'axios'
import {safeLandingPath} from '@/navigation-context'

export default {

  data() {
    return {
      showStartUpMessage: false,
      showerr: false,
      loginError: '',
      loggingIn: false,
      username: '',
      password: '',
      loginname: 'تسجيل دخول',
      SamMessage: '',
      clientStatus: '',
      langname: "ar",
      branches: [],
      defBranch: 1,
      financeYear: [],
      fYear: (new Date()).getFullYear()
    }
  },
  computed: {
    nameState() {
      return this.username.length > 2 ? true : false
    },
    passState() {
      return this.password.length > 2 ? true : false
    },
    lang() {
      return this.$store.state.lang[this.langname] || this.$store.state.lang.ar;
    },
    FinYears: function(){
      let t = [];
      for(let i=0;i<this.financeYear.length;i++){
        t.push({text: this.financeYear[i], value: this.financeYear[i]})
      }
      return t;
    }
  },
  beforeCreate() {
    //this.getStart();
  },
  created() {
    localStorage.setItem('defBranch', 1);
    localStorage.setItem('financeYear', (new Date()).getFullYear());
    this.changeLang(this.$cookies.get(this.$store.state.LangCooki) || this.$store.state.deflang || 'ar');
    this.getStart();
  },
  methods: {
    setFinanceYear(){
      localStorage.setItem('financeYear',this.fYear);
    },
    changeBranch(id) {
      if (!this.branches.some(branch => String(branch.id) === String(id))) return false;
      this.defBranch = id;
      localStorage.setItem('defBranch', id);
      return true;
    },
    changeLang(id, sub) {
      if (!['ar','en','ur'].includes(id)) id = 'ar';
      if (this.$store.state.licenseType.activemenu === 'ofatora' && id === 'ar') id = 'ur';
      this.langname = id;
      this.$store.state.deflang = id;
      this.$cookies.set(this.$store.state.LangCooki, id);
      localStorage.setItem('subLang', id);
    },
    languageButtonStyle(locale) {
      return {background: this.langname === locale ? '#84c8ff' : '#eeeeee', color: '#000'};
    },
    branchButtonStyle(id) {
      return {background: String(this.defBranch) === String(id) ? '#84c8ff' : '#eeeeee', color: '#000'};
    },
    enterlogin(){
      // e.preventDefault();
      // if (event.keyCode == 13){
        // if(this.username == '') {
        //   document.getElementById('username').focus();
        //   return false;
        // }
        // if(this.password == '' && this.username != '') {
        //   document.getElementById('password').focus();
        //   return false;
        // }
        // this.doLogin();

    },
    async getStart() {
      const pp = new FormData();
      pp.append('defBranch', localStorage.getItem('defBranch'));
      pp.append('financeYear', localStorage.getItem('financeYear'));
      pp.append('type', 'getMeTodo');
      try {
        const {data: res} = await axios.post(this.$store.state.SAMCOTEC.r_path, pp);
        if (!res || !res.error || Number(res.error.number) !== 200 || !res.results || !res.results.data) throw new Error('startup_failed');
        const value = res.results;
        this.$store.state.loginRedirect = value.redirectURl;
        localStorage.setItem('redirectURl', JSON.stringify(value.redirectURl));
        this.branches = Array.isArray(value.branches) ? value.branches : [];
        this.financeYear = Array.isArray(value.financeYear) ? value.financeYear : [];
        if (this.branches.length && !this.branches.some(branch => String(branch.id) === String(this.defBranch))) this.changeBranch(this.branches[0].id);
        if (this.financeYear.length && !this.financeYear.some(year => Number(year) === Number(this.fYear))) this.fYear = this.financeYear[this.financeYear.length - 1];
        this.setFinanceYear();
        localStorage.setItem('_ECar_', JSON.stringify(value.data));
        this.$store.commit('setLicenseType', value.data);
        this.changeLang(this.langname, this.langname);
        return true;
      } catch (error) {
        this.showerr = true;
        this.loginError = this.lang.system_login_unavailable;
        return false;
      }
    },
    async doLogin() {
      if (this.loggingIn) return false;
      this.showerr = false;
      this.loginError = '';
      if (!this.username.trim() || !this.password) {
        this.showerr = true;
        this.loginError = this.lang.required_field;
        return false;
      }
      this.loggingIn = true;
      const pp = new FormData();
      pp.append('defBranch', this.defBranch);
      pp.append('financeYear', this.fYear);
      pp.append('type', 'register');
      pp.append('data[username]', this.username.trim());
      pp.append('data[password]', this.password);
      pp.append('data[defBranch]', this.defBranch);
      try {
        const {data: res} = await axios.post(this.$store.state.SAMCOTEC.r_path, pp);
        const user = res && res.results && res.results.data;
        if (!res || !res.error || Number(res.error.number) !== 200 || !user || !Number.isInteger(Number(user.ID)) || Number(user.ID) < 1 || !res.results.hash) {
          this.showerr = true;
          this.loginError = this.lang.system_login_invalid;
          return false;
        }
        this.$store.state.userinfo = user;
        const code = user.ID+'||'+res.results.hash+'||DM3-CMS-M33-103-650||'+res.results.time+'||'+this.langname+'||'+this.defBranch;
        this.$cookies.set(this.$store.state.COOKIEPhase, code, 86400);
        this.$store.state.group_id = user.group_id;
        const landing = Number(user.group_id) === 9 ? '/clientList-mobile' : safeLandingPath(user.redirectURl);
        this.$store.state.loginRedirect = landing;
        localStorage.setItem('currentMenu', 1);
        this.password = '';
        if (this.$route.path !== landing) await this.$router.push({path: landing});
        return true;
      } catch (error) {
        this.showerr = true;
        this.loginError = this.lang.system_login_unavailable;
        return false;
      } finally {
        this.loggingIn = false;
      }
    }
  },
}
</script>
<style>
.body{
  border:3px inset #000;
  background:#84c8ff !important;
  color:#000;
  height: 100vh;
}
.bgbalck{
  background:rgb(0,0,0) !important;
  color:#FFF !important;
}
.errorMesg{
  background:rgba(0, 0, 0,0.5);
  padding:5px;
  width:50%;
  margin:auto;
  border-radius: .8rem;
}
.loginSupport{
  z-index:4000;
  /* position: absolute; */
  margin-top:10px;
  bottom: 0px;
  left: 0;
  right:0;
  padding:5px;
  text-align:center;
  font-size:1.2rem;
  /* background:#000; */
  color:#000;
}
</style>